import React, {useEffect, useRef, useState} from 'react';
import Header from '../components/Header'
import {useSeo} from "../hooks/useMetadata";

const Sooniverse = () => {
    const [days, setDays] = useState('۰۰');
    const [hours, setHours] = useState('۰۰');
    const [minutes, setMinutes] = useState('۰۰');
    const [seconds, setSeconds] = useState('۰۰');
    const vantaRef = useRef(null);
    const vantaEffect = useRef(null);

    useEffect(() => {
        // Load external scripts
        const loadScripts = async () => {
            // Load Tailwind CSS
            if (!document.querySelector('script[src*="tailwind"]')) {
                const tailwindScript = document.createElement('script');
                tailwindScript.src = 'https://cdn.tailwindcss.com';
                document.head.appendChild(tailwindScript);
            }

            // Load Feather Icons
            if (!document.querySelector('script[src*="feather"]')) {
                const featherScript = document.createElement('script');
                featherScript.src = 'https://unpkg.com/feather-icons';
                featherScript.onload = () => {
                    if (window.feather) window.feather.replace();
                };
                document.head.appendChild(featherScript);
            }

            // Load Vanta.js
            if (!document.querySelector('script[src*="vanta"]')) {
                const vantaScript = document.createElement('script');
                vantaScript.src = 'https://cdn.jsdelivr.net/npm/vanta@latest/dist/vanta.globe.min.js';
                vantaScript.onload = () => {
                    initializeVanta();
                };
                document.head.appendChild(vantaScript);
            } else {
                initializeVanta();
            }
        };

        const initializeVanta = () => {
            if (window.VANTA && vantaRef.current) {
                vantaEffect.current = window.VANTA.GLOBE({
                    el: vantaRef.current,
                    mouseControls: true,
                    touchControls: true,
                    gyroControls: false,
                    minHeight: 200.00,
                    minWidth: 200.00,
                    scale: 1.00,
                    scaleMobile: 1.00,
                    color: 0x3f3f46,
                    backgroundColor: 0x0f0f0f,
                    size: 1.10
                });
            }
        };

        loadScripts();

        // Initialize countdown
        const launchDate = new Date('2024-12-31T00:00:00').getTime(); // Set your launch date here

        const updateCountdown = () => {
            const now = new Date().getTime();
            const distance = launchDate - now;

            if (distance < 0) {
                // Launch time reached
                setDays('۰۰');
                setHours('۰۰');
                setMinutes('۰۰');
                setSeconds('۰۰');
                return;
            }

            const daysValue = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hoursValue = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutesValue = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const secondsValue = Math.floor((distance % (1000 * 60)) / 1000);

            // Convert to Persian numerals
            setDays(convertToPersianNumber(daysValue.toString().padStart(2, '0')));
            setHours(convertToPersianNumber(hoursValue.toString().padStart(2, '0')));
            setMinutes(convertToPersianNumber(minutesValue.toString().padStart(2, '0')));
            setSeconds(convertToPersianNumber(secondsValue.toString().padStart(2, '0')));
        };

        updateCountdown();
        const countdownInterval = setInterval(updateCountdown, 1000);

        // Update Feather icons periodically since they might load after component mount
        const featherInterval = setInterval(() => {
            if (window.feather) {
                window.feather.replace();
            }
        }, 1000);

        return () => {
            if (vantaEffect.current) {
                vantaEffect.current.destroy();
            }
            clearInterval(countdownInterval);
            clearInterval(featherInterval);
        };
    }, []);

    // Function to convert English numbers to Persian numbers
    const convertToPersianNumber = (number) => {
        const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
        return number.toString().replace(/\d/g, (digit) => persianNumbers[digit]);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const email = e.target.email?.value;
        // Handle email submission logic here
        console.log('Email submitted:', email);
        alert('با تشکر از شما! به زودی شما را مطلع خواهیم کرد.');
        e.target.reset();
    };

    const CountdownBox = ({value, label}) => (
        <div
            className="countdown-number rounded-xl p-4 w-20 h-20 md:w-24 md:h-24 flex flex-col items-center justify-center">
            <span className="text-2xl md:text-3xl font-bold">{value}</span>
            <span className="text-xs uppercase opacity-70">{label}</span>
        </div>
    );
    useSeo(
        'استودیو بازیسازی مدریک: به زودی باز خواهیم گشت.',
        'به استودیوی بازیسازی مدریک خوش آمدید. به زودی باز خواهیم گشت.',
        {keywords: 'medrick, game studio, mobile game'}
    );
    return (
        <>
            <Header title=" بی‌خیالش ! بازی کن"/>
            <style jsx>{`
                @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600;700&display=swap');

                .sooniverse-container {
                    font-family: 'Poppins', sans-serif;
                    direction: rtl;
                    background-color: #000000;
                }

                #vanta-bg {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    z-index: -1;
                }

                .countdown-number {
                    background: rgba(255, 255, 255, 0.1);
                    backdrop-filter: blur(10px);
                }

                /* Persian font support */
                @font-face {
                    font-family: 'Vazir';
                    src: url('https://cdn.jsdelivr.net/gh/rastikerdar/vazir-font@v30.1.0/dist/Vazir.woff2') format('woff2');
                }

                .persian-text {
                    font-family: 'Vazir', 'Poppins', sans-serif;
                }
            `}</style>

            <div
                className="sooniverse-container flex items-center justify-center text-white overflow-hidden persian-text">
                <div id="vanta-bg" ref={vantaRef}/>

                <div className="container mx-auto px-4 py-16 text-center relative z-10">
                    <div className="max-w-4xl mx-auto">
                        <h1 className="text-5xl md:text-7xl font-bold mb-6 animate-pulse">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-pink-500 to-violet-500">
                همکاران در حال کارند...
              </span>
                        </h1>

                        <p className="text-xl md:text-2xl mb-12 opacity-90 max-w-2xl mx-auto">
                            ما در حال ساخت چیزی فوق العاده هستیم! رونمایی با شکوه ما به زودی انجام خواهد شد.
                        </p>

                        <div className="flex justify-center mb-16">
                            <div className="grid grid-cols-4 gap-4">
                                <CountdownBox value={days} label="روز"/>
                                <CountdownBox value={hours} label="ساعت"/>
                                <CountdownBox value={minutes} label="دقیقه"/>
                                <CountdownBox value={seconds} label="ثانیه"/>
                            </div>
                        </div>

                        <div className="mb-16">
                            <p className="text-lg mb-6">برای اطلاع از آخرین اخبار درباره ما عضو شوید</p>
                            <form onSubmit={handleSubmit} className="max-w-md mx-auto flex">
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="آدرس ایمیل شما"
                                    className="flex-grow px-4 py-3 rounded-r-lg bg-white bg-opacity-10 border border-white border-opacity-20 focus:outline-none focus:ring-2 focus:ring-pink-500 text-white placeholder-gray-300 text-right"
                                    required
                                    dir="rtl"
                                />
                                <button
                                    type="submit"
                                    className="px-6 py-3 bg-gradient-to-r from-pink-500 to-violet-500 rounded-l-lg font-medium hover:opacity-90 transition-opacity"
                                >
                                    به من اطلاع بده
                                </button>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default Sooniverse;